<template>
  <Loading :loading="loading" class="orders row">
    <h2 class="col-12">My Favourites</h2>
    <div class="col-12">
      <div v-if="favourites && favourites.length >0" class="row itemContainer">
        <!-- <transition-group name="fade" class="col-12 col-md-10"> -->
        <div
          class="favouriteItem col-12 col-sm-6 col-md-4 col-lg-3"
          v-for="favourite in favourites"
          :key="favourite.id"
        >
          <div>
          <ListItem :key="favourite.id" :item="favourite"/>
        </div>
          <FavouritesCartButton :product="favourite"/>
          <div class="col-12 remove btn btn-outline-warning" @click.stop="() => {deleteFavouriteClicked(favourite.id)}">Remove</div>
        </div>
        <!-- </transition-group> -->
      </div>
      <div v-else>
        <p>You haven't added any favourites yet.</p>
        <p>You can add favourites by clicking the heart icon next to products in the shop.</p>
        <router-link :to="{name:'shop'}" class="btn btn-primary">Shop Now</router-link>
      </div>
    </div>
  </Loading>
</template>

<script>
import { fetchFavourites, deleteFavourite } from "@/network/favouritesRequests";
import ListItem from "@/sections/shop/listing/ListItem";
import Loading from "@/components/loading/Loading";
import FavouritesCartButton from "./FavouritesCartButton";

export default {
  name: "MyFavourites",
  components: {
    Loading,
    ListItem,
    FavouritesCartButton
  },
  data() {
    return {
      favourites: null,
      loading: false
    };
  },
  created() {
    this.loading = true;
    fetchFavourites(favourites => {
      this.favourites = favourites;
      this.loading = false;
    });
  },
  methods: {
    deleteFavouriteClicked(id) {
      this.favourites = this.favourites.filter(item => item.id != id); //remove deleted item locally
      this.gtmEvent(id)
      deleteFavourite(id); //remove on server
    },
    gtmEvent(id) {
			this.$gtm.trackEvent({
				event: "removeFromFavourites",
				value: id
			})
		}
  }
};
</script>

<style lang="scss" scoped>
.favouriteItem {
  padding-bottom: 10px;
}

.remove{
  margin-top: 10px;
  &:active{
    color: #fff;
    background-color: $CTgold;
  }
}
</style>
